import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    phonecall: "13027502546"
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
